enum ProductFeatures {
    PLAN_REVIEW = 'PlanReview',
    EDIT_REQUIRED_VALUE_PR = 'EditRequiredValuePR',
    MANAGE_CUSTOM_FIELDS_PR = 'ManageCustomFieldsPR',
    CREATE_PROJECT_PAGE = 'CreateProjectPage',
    CREATE_PROJECT = 'CreateProject',
    ACCOUNT_PAGE = 'AccountPage',
    UPGRADE_SUBSCRIPTION = 'UpgradeSubscription',
    PUBLIC_LINK = 'PublicLink',
    ECI = 'ECI',
    ECI_PUBLISH_DRAFT = 'ECIPublishDraft',
    ECI_CREATE_ZC_DRAFT = 'ECICreateZCDraft',
    ECI_CALIBRATION_ADMIN_PAGE = 'ECICalibrationAdminPage',
    ECI_EXPORT_ZC_TO_XLSX = 'ECIExportZCToXLSX'
}

export { ProductFeatures };
